require('./bootstrap');
// const {Chat} =  require('./chat');
const {SigmaChat} = require('./sigma-chat');
window.SigmaChat = SigmaChat
// require('alpinejs');
